// extracted by mini-css-extract-plugin
export default {"cls1":"ResearchInterestTags-cls1__Qx","cls2":"ResearchInterestTags-cls2_L5C ResearchInterestTags-cls1__Qx"};